import { Box, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomChip } from '../../../../../components/Chip';
import { LANG_TEXT } from '../../../../../constants/language';
import { useAuthContext } from '../../../../../context/authContext';
import { convertText } from '../../../../../utils/common';
import { getOverallStatus } from '../../../../../utils/multiOrder.utils';
import { STATUS_COLOR_MAP } from '../../../data';
import { DamagedItemStatus, Order, OrderItemStatus } from '../../../order.types';

const OrderIdSection: React.FC<{ item: Order }> = ({ item }) => {
  const { t } = useTranslation();
  const { user } = useAuthContext();

  const myOrders = item.multi_orders?.filter((order) => order.rider_id === user?.uid);
  const totalStatus = getOverallStatus(myOrders || []);

  const status = useMemo(() => {
    const statusMap = {
      [OrderItemStatus.PREPARING]: t(LANG_TEXT.PREPARING),
      [OrderItemStatus.DAMAGED_PREPARING]: t(LANG_TEXT.PREPARING),
      [OrderItemStatus.READY_FOR_PICK_UP]: t(LANG_TEXT.READY_FOR_PICK_UP),
      [OrderItemStatus.DAMAGED_READY_FOR_PICK_UP]: t(LANG_TEXT.READY_FOR_PICK_UP),
      [OrderItemStatus.DELIVERING]: t(LANG_TEXT.DELIVERING),
      [OrderItemStatus.DAMAGED_DELIVERING]: t(LANG_TEXT.DELIVERING),
      [OrderItemStatus.DELIVERED]: t(LANG_TEXT.DELIVERED),
      [DamagedItemStatus.CANCELLED]: t(LANG_TEXT.CANCELLED),
      [DamagedItemStatus.DAMAGED_CANCELLED]: t(LANG_TEXT.CANCELLED),
    };
    if (item?.multi_orders && item?.multi_orders.length > 1) {
      return {
        text: convertText(myOrders?.length && totalStatus ? statusMap[totalStatus] : t(LANG_TEXT.NEW)),
        status: totalStatus,
      };
    }

    return {
      text: convertText(item?.rider_id ? statusMap[item.order_status] : t(LANG_TEXT.NEW)),
      status: item?.rider_id ? item.order_status : OrderItemStatus.PREPARING,
    };
  }, [item.multi_orders, item.order_status, item?.rider_id, user?.uid]);

  return (
    <Box bgcolor="white" padding="16px" display="flex" flexDirection="column" alignItems="center" gap="8px" borderBottom="1px solid #EAECF0">
      <CustomChip
        size="md"
        bgcolor={STATUS_COLOR_MAP[status.status || OrderItemStatus.PREPARING].bgColor}
        color={STATUS_COLOR_MAP[status.status || OrderItemStatus.PREPARING].color}
        textTransform="capitalize"
      >
        {status.text}
      </CustomChip>
      <Box display="flex" padding="12px 0px" width="100%" flexDirection="column" alignItems="center" gap="4px" bgcolor="#F2FBF3">
        <Typography fontSize="14px" color="#667085" fontWeight="500">
          {t(LANG_TEXT.ORDER_ID)}
        </Typography>
        <Typography fontSize="26px" color="#1D2939" fontWeight="600">
          {item.id} {item.has_damaged_order ? ` (${t(LANG_TEXT.DAMAGED)})` : ''}
        </Typography>
      </Box>
    </Box>
  );
};

export default OrderIdSection;
